module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('gs-header', {
    attrs: {
      "title": "Thêm mới mã giảm giá",
      "breadcrumbs": [{
        title: 'Quản lý mã giảm giá',
        route: {
          name: 'promotion'
        }
      }]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "padding-all"
  }, [_c('el-form', {
    ref: "createPromotionForm",
    attrs: {
      "model": _vm.localPromotion,
      "rules": _vm.rules,
      "label-width": "200px",
      "label-position": "top"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateBeforeSubmitCity('createPromotionForm')
      }
    }
  }, [_c('el-row', {
    staticClass: "remove-margin",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Mã giảm giá ",
      "prop": "code"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Mã giảm giá"
    },
    model: {
      value: (_vm.localPromotion.code),
      callback: function($$v) {
        _vm.$set(_vm.localPromotion, "code", $$v)
      },
      expression: "localPromotion.code"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "adddon-1",
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Số tiền ",
      "prop": "discount"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "Số tiền"
    },
    model: {
      value: (_vm.localPromotion.discount),
      callback: function($$v) {
        _vm.$set(_vm.localPromotion, "discount", $$v)
      },
      expression: "localPromotion.discount"
    }
  }, [_c('el-select', {
    attrs: {
      "slot": "prepend",
      "placeholder": "Đơn vị"
    },
    slot: "prepend",
    model: {
      value: (_vm.localPromotion.is_percent),
      callback: function($$v) {
        _vm.$set(_vm.localPromotion, "is_percent", $$v)
      },
      expression: "localPromotion.is_percent"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "đ",
      "value": false
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "%",
      "value": true
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "append"
    },
    slot: "append"
  }, [_c('span', {
    staticClass: "text-red"
  }, [(!_vm.localPromotion.is_percent) ? _c('span', [_vm._v(_vm._s(_vm._f("vnd")(_vm.localPromotion.discount)))]) : _c('span', [_vm._v(_vm._s(_vm.localPromotion.discount) + "%")])])])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Số tiền lớn nhất ",
      "prop": "max_discount"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "Số tiền lớn nhất"
    },
    model: {
      value: (_vm.localPromotion.max_discount),
      callback: function($$v) {
        _vm.$set(_vm.localPromotion, "max_discount", $$v)
      },
      expression: "localPromotion.max_discount"
    }
  }, [_c('div', {
    attrs: {
      "slot": "append"
    },
    slot: "append"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.localPromotion.max_discount)))])])])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Số lượng ",
      "prop": "quantity"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "Số lượng"
    },
    model: {
      value: (_vm.localPromotion.quantity),
      callback: function($$v) {
        _vm.$set(_vm.localPromotion, "quantity", $$v)
      },
      expression: "localPromotion.quantity"
    }
  }, [_c('div', {
    attrs: {
      "slot": "append"
    },
    slot: "append"
  }, [_c('span', {
    staticClass: "text-orange"
  }, [_vm._v(_vm._s(_vm._f("number")(_vm.localPromotion.quantity)))])])])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Số lượng áp dụng cho từng user",
      "prop": "quantity"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "Số lượng áp dụng cho từng user"
    },
    model: {
      value: (_vm.localPromotion.quantity_per_user),
      callback: function($$v) {
        _vm.$set(_vm.localPromotion, "quantity_per_user", $$v)
      },
      expression: "localPromotion.quantity_per_user"
    }
  }, [_c('div', {
    attrs: {
      "slot": "append"
    },
    slot: "append"
  }, [_c('span', {
    staticClass: "text-orange"
  }, [_vm._v(_vm._s(_vm._f("number")(_vm.localPromotion.quantity_per_user)))])])])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Ngày bắt đầu",
      "prop": "start_date"
    }
  }, [_c('el-date-picker', {
    staticClass: "width-100",
    attrs: {
      "type": "date",
      "placeholder": "Ngày bắt đầu"
    },
    on: {
      "change": function($event) {
        return _vm.dateFormat('start_date')
      }
    },
    model: {
      value: (_vm.localPromotion.start_date),
      callback: function($$v) {
        _vm.$set(_vm.localPromotion, "start_date", $$v)
      },
      expression: "localPromotion.start_date"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Ngày kết thúc",
      "prop": "end_date"
    }
  }, [_c('el-date-picker', {
    staticClass: "width-100",
    attrs: {
      "type": "date",
      "placeholder": "Ngày kết thúc"
    },
    on: {
      "change": function($event) {
        return _vm.dateFormat('end_date')
      }
    },
    model: {
      value: (_vm.localPromotion.end_date),
      callback: function($$v) {
        _vm.$set(_vm.localPromotion, "end_date", $$v)
      },
      expression: "localPromotion.end_date"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Nguồn đơn",
      "prop": "is_active"
    }
  }, [_c('el-select', {
    staticClass: "width-100",
    attrs: {
      "placeholder": "Nguồn đơn"
    },
    model: {
      value: (_vm.localPromotion.source),
      callback: function($$v) {
        _vm.$set(_vm.localPromotion, "source", $$v)
      },
      expression: "localPromotion.source"
    }
  }, _vm._l((_vm.promotionHelpers.sources), function(source, key, index) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": source,
        "value": key.toString()
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Hãng vận chuyển",
      "prop": "carrier_id"
    }
  }, [_c('el-select', {
    staticClass: "width-100",
    attrs: {
      "placeholder": "Hãng vận chuyển"
    },
    model: {
      value: (_vm.localPromotion.carrier_id),
      callback: function($$v) {
        _vm.$set(_vm.localPromotion, "carrier_id", $$v)
      },
      expression: "localPromotion.carrier_id"
    }
  }, [_c('el-option', {
    key: "0",
    attrs: {
      "label": "Tất cả",
      "value": "0"
    }
  }), _vm._v(" "), _vm._l((_vm.carriers), function(carrier) {
    return _c('el-option', {
      key: carrier.id,
      attrs: {
        "label": carrier.name,
        "value": carrier.id.toString()
      }
    })
  })], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tỉnh thành đi",
      "prop": "city_from"
    }
  }, [_c('el-select', {
    staticClass: "width-100",
    attrs: {
      "placeholder": "Tỉnh thành đi"
    },
    model: {
      value: (_vm.localPromotion.city_from),
      callback: function($$v) {
        _vm.$set(_vm.localPromotion, "city_from", $$v)
      },
      expression: "localPromotion.city_from"
    }
  }, [_c('el-option', {
    key: "0",
    attrs: {
      "label": "Tất cả",
      "value": "0"
    }
  }), _vm._v(" "), _vm._l((_vm.cities), function(city) {
    return (city.allow) ? _c('el-option', {
      key: city.id,
      attrs: {
        "label": city.name,
        "value": city.id.toString()
      }
    }) : _vm._e()
  })], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tỉnh thành đến",
      "prop": "city_to"
    }
  }, [_c('el-select', {
    staticClass: "width-100",
    attrs: {
      "placeholder": "Tỉnh thành đến"
    },
    model: {
      value: (_vm.localPromotion.city_to),
      callback: function($$v) {
        _vm.$set(_vm.localPromotion, "city_to", $$v)
      },
      expression: "localPromotion.city_to"
    }
  }, [_c('el-option', {
    key: "0",
    attrs: {
      "label": "Tất cả",
      "value": "0"
    }
  }), _vm._v(" "), _vm._l((_vm.cities), function(city) {
    return _c('el-option', {
      key: city.id,
      attrs: {
        "label": city.name,
        "value": city.id.toString()
      }
    })
  })], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Trạng thái",
      "prop": "is_active"
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.localPromotion.is_active),
      callback: function($$v) {
        _vm.$set(_vm.localPromotion, "is_active", $$v)
      },
      expression: "localPromotion.is_active"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Mô tả ",
      "prop": "description"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "Mô tả"
    },
    model: {
      value: (_vm.localPromotion.description),
      callback: function($$v) {
        _vm.$set(_vm.localPromotion, "description", $$v)
      },
      expression: "localPromotion.description"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Banner (600x600)"
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": _vm.uploadLogoUrl,
      "headers": _vm.uploadHeader,
      "show-file-list": false,
      "on-success": _vm.handleLogoUpload,
      "before-upload": _vm.beforeLogoUpload
    }
  }, [(_vm.image.path) ? _c('img', {
    staticClass: "banner-promotion",
    attrs: {
      "src": _vm.image.path
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('button', {
    staticClass: "ui blue basic small button",
    attrs: {
      "disabled": _vm.submitting,
      "native-type": "submit"
    }
  }, [_vm._v("Thêm mới")])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-55220811"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/promotion/NewPromotion.vue
// module id = 709
// module chunks = 1